module.exports = __webpack_public_path__ + "static/img/smbg2.186249f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/smbg2.png
// module id = 9tEZ
// module chunks = 1